module.exports = __webpack_public_path__ + "static/media/horizontal_sem_foto.e7a2c158.png";